import { useEffect } from "react";
import { useImmer } from "use-immer";

export const useAuth = () => {
  const [auth, setAuth] = useImmer({
    isInitialLoad: true,
    data: {
      id: null,
      name: "",
      first_name: "",
      last_name: "",
      email: "",
      token: "",
      roles: [],
      permissions: [],
      selectedStoreId: null,
      stores: [],
    },
  });
  useEffect(() => {
    setAuth((draft) => {
      draft.isInitialLoad = false;
    });
    const localStorageData = JSON.parse(localStorage.getItem("pos-user-data"));
    if (localStorageData !== null) {
      setAuth((draft) => {
        draft.data = localStorageData;
      });
    }
  }, []);

  useEffect(() => {
    if (auth.data.id) {
      localStorage.setItem("pos-user-data", JSON.stringify(auth.data));
    }
  }, [auth]);

  return { auth, setAuth };
};
